<template>
  <div>
    <h3>Werkstatttermin vereinbaren</h3>

    <div v-if="!identityToken">

      <h4>Ihre Daten</h4>

      <div class="form-row">

        <div class="form-group col-md-6">
          <label class="form-label" for="firstname">Vorname:</label>
          <input type="text" v-model="formData.firstname" class="form-control" id="firstname" name="firstname">
        </div>

        <div class="form-group col-md-6">
          <label class="form-label" for="lastname">Name<span class="text-danger">*</span>:</label>
          <input type="text" v-model="formData.lastname" class="form-control" id="lastname" name="lastname">
          <div class="invalid-feedback d-block" v-if="formerrors.includes('lastname')">
            Bitte geben Sie Ihren Namen an.
          </div>
        </div>

      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="form-label" for="mobile">Mobilnummer<span class="text-danger">*</span>:</label>
          <vue-tel-input
              v-model="formData.mobile"
              :preferred-countries="['de', 'at', 'ch']"
              :default-country="'de'"
              placeholder="Mobilnummer eingeben"
              :input-options="{
                id: 'mobile',
                name: 'mobile',
                class: 'form-control'
              }"
              @validate="onPhoneValidate"
              @input="onPhoneInput"
              mode="international"
              :auto-format="true"
              :format-on-display="true"
              :include-country-code="true"
          ></vue-tel-input>
          <div class="invalid-feedback d-block" v-if="formerrors.includes('mobile')">
            Bitte geben Sie eine gültige Mobilnummer an.
          </div>
        </div>

        <div class="form-group col-md-6">
          <label class="form-label" for="email">E-Mail:</label>
          <input type="email" v-model="formData.email" class="form-control" id="email" name="email">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="form-label" for="licenseplate">Kennzeichen<span class="text-danger">*</span>:</label>
          <input type="text" v-model="formData.licenseplate" class="form-control" id="licenseplate" name="licenseplate">
          <div class="invalid-feedback d-block" v-if="formerrors.includes('licenseplate')">
            Bitte geben Sie Ihr Kennzeichen an.
          </div>
        </div>

        <div class="form-group col-md-6">
          <label class="form-label" for="manufacturer">Hersteller<span class="text-danger">*</span>:</label>
          <input type="text" v-model="formData.manufacturer" class="form-control" id="manufacturer" name="manufacturer">
          <div class="invalid-feedback d-block" v-if="formerrors.includes('manufacturer')">
            Bitte geben Sie den Hersteller an.
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="form-label" for="model">Modell:</label>
          <input type="text" v-model="formData.model" class="form-control" id="model" name="model">
        </div>
      </div>

    </div>

    <div class="form-group">
      <label class="form-label">Bemerkung:</label>
      <textarea name="description" v-model="formData.comment" class="form-control"></textarea>
      <p class="small text-muted">Platz für zusätzliche Infos.</p>
    </div>

    <!-- Fahrzeugschein Upload -->
    <KSRFahrzeugscheinUpload
        ref="fahrzeugscheinUpload"
        :required="content && content.setting_service_registration_required"
        :has-error="formerrors.includes('registration_document')"
        @update="onFahrzeugscheinUpdate"
    />

    <div v-if="identityToken">
      <div class="form-row">
        <div class="form-group col-md-12">
          <button class="btn btn-secondary my-3 mr-2" @click="goBack()">Zurück</button>
          <button class="btn btn-primary my-3" @click="onSubmit()" :disabled="isSubmitting">
            <span v-if="isSubmitting">Wird gesendet...</span>
            <span v-else>Jetzt buchen</span>
          </button>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="form-row">
        <div class="form-group col-md-12">
          <button class="btn btn-secondary my-3 mr-2" @click="goBack()">Zurück</button>
          <button class="btn btn-primary my-3" @click="onSubmitAppointment()" :disabled="isSubmitting || showPhoneVerificationBox">
            <span v-if="isSubmitting">Wird gesendet...</span>
            <span v-else>Jetzt buchen</span>
          </button>
        </div>
      </div>
    </div>

    <div class="mt-2 text-danger"><small>* = Erforderlich</small></div>

    <div v-if="showPhoneVerificationBox && !waitForBookingConfirmation">
      <KSRPhoneVerification @verficationStatus="onVerficationStatus"></KSRPhoneVerification>
      <!-- Error message -->
      <div v-if="verificationError" class="alert alert-danger mt-3">
        {{ verificationError }}
      </div>
    </div>

    <div v-if="waitForBookingConfirmation" class="loading-container">
      <div class="spinner"></div>
      <p class="loading-text">Bitte warten...</p>
    </div>

    <!-- Error message -->
    <div v-if="apiError" class="alert alert-danger mt-3">
      {{ apiError }}
    </div>

  </div>
</template>

<script>
import KSRPhoneVerification from "./KSRPhoneVerification.vue";
import KSRUploadDocuments from "./KSRUploadDocuments";
import KSRSelectVehicle from "./KSRSelectVehicle.vue";
import KSRFahrzeugscheinUpload from "./KSRFahrzeugscheinUpload.vue";

export default {
  name: 'KSRServiceForm',
  components: { KSRPhoneVerification, KSRUploadDocuments, KSRSelectVehicle, KSRFahrzeugscheinUpload },
  data() {
    return {
      studioId: false,
      formData: {
        // Personal Information
        lastname: '',
        firstname: '',
        mobile: '',
        email: '',

        // Vehicle Information
        licenseplate: '',
        manufacturer: '',
        brand: '',
        model: '',
        ez: '',
        vin: '',
        vehicleId: false,

        // Service Selection
        selectedArea: '',
        selectedGroup: '',
        selectedService: '',
        selectedServices: [],
        selectedAdditionalOptions: [],

        // Appointment & Options
        appointment: '',
        selectedAppointmentSlot: null,
        currentDay: null,
        optionInKey: '',
        optionOutKey: '',
        replacementvehicle: false,

        // Additional Information
        description: '',
        comment: '',
        infos: '',
        offerviaemail: false,

        // Fahrzeugschein files
        files_registration: []
      },
      formerrors: [],
      isSubmitting: false,
      apiError: '',
      isPhoneValid: false,
      phoneObject: null,
      // Data from localStorage
      selectedSlotStart: '',
      selectedEmployeeId: '',
      typeDetails: {},
      insuranceData: {},
      showPhoneVerificationBox: false,
      verificationError: false,
      waitForBookingConfirmation: false,
      tempToken: null,
      identityToken: null
    }
  },
  computed: {
    content() {
      return this.$parent.content || {};
    }
  },
  created() {
    this.studioId = this.$parent.studioId;
    // Load data from localStorage when component is created
    this.loadFromLocalStorage();
    // for a guest booking generate a random token
    this.tempToken = Math.random().toString(36).substr(2) + Date.now().toString(36);
    // Check for identityToken
    this.identityToken = sessionStorage.getItem('identityToken');
  },
  methods: {
    loadFromLocalStorage() {
      try {
        const savedData = localStorage.getItem('formdata');
        if (savedData) {
          const parsedData = JSON.parse(savedData);

          if (this.isValidFormData(parsedData)) {
            this.formData = {
              ...this.formData, // Keep defaults
              ...this.sanitizeFormData(parsedData)
            };
          }
        }
      } catch (error) {
        console.error('Error loading from localStorage:', error);
        localStorage.removeItem('formdata');
      }
    },

    isValidFormData(data) {
      if (!data || typeof data !== 'object' || Array.isArray(data)) {
        return false;
      }

      const schema = {
        selectedArea: 'string',
        selectedGroup: 'string',
        selectedService: 'string',
        selectedServices: 'array',
        selectedAdditionalOptions: 'array',
        optionInKey: 'string',
        optionOutKey: 'string',
        selectedAppointmentSlot: 'object',
        comment: 'string',
        currentDay: 'string',
        licenseplate: 'string',
        ez: 'string',
        brand: 'string',
        model: 'string',
        vin: 'string'
      };

      for (const [key, expectedType] of Object.entries(schema)) {
        if (data.hasOwnProperty(key)) {
          const actualType = Array.isArray(data[key]) ? 'array' :
              data[key] === null ? 'null' : typeof data[key];

          if (expectedType !== actualType && !(expectedType === 'object' && actualType === 'null')) {
            console.warn(`Invalid type for ${key}: expected ${expectedType}, got ${actualType}`);
            return false;
          }
        }
      }

      return true;
    },

    sanitizeFormData(data) {
      const sanitized = {};

      const stringFields = ['selectedArea', 'selectedGroup', 'selectedService',
        'optionInKey', 'optionOutKey', 'comment', 'licenseplate',
        'ez', 'brand', 'model', 'vin'];

      stringFields.forEach(field => {
        if (data[field] && typeof data[field] === 'string') {
          sanitized[field] = data[field].trim().substring(0, 500);
        }
      });

      if (data.currentDay && typeof data.currentDay === 'string') {
        try {
          const date = new Date(data.currentDay);
          if (!isNaN(date.getTime())) {
            sanitized.currentDay = data.currentDay;
          }
        } catch (e) {
          console.warn('Invalid date format for currentDay');
        }
      }

      if (Array.isArray(data.selectedServices)) {
        sanitized.selectedServices = data.selectedServices.filter(service =>
            service && typeof service === 'object' && service.key
        );
      }

      if (Array.isArray(data.selectedAdditionalOptions)) {
        sanitized.selectedAdditionalOptions = data.selectedAdditionalOptions.filter(option =>
            option && typeof option === 'object'
        );
      }

      if (data.selectedAppointmentSlot && typeof data.selectedAppointmentSlot === 'object') {
        if (this.isValidAppointmentSlot(data.selectedAppointmentSlot)) {
          sanitized.selectedAppointmentSlot = data.selectedAppointmentSlot;
        }
      }

      return sanitized;
    },

    isValidAppointmentSlot(slot) {
      return slot &&
          Array.isArray(slot.appointmentSlots) &&
          Array.isArray(slot.serviceSlots) &&
          Array.isArray(slot.missingServiceOptions);
    },
    formatToMunichTime(isoString) {
      if (!isoString) return 'Nicht verfügbar';

      try {
        const date = new Date(isoString);
        return date.toLocaleString('de-DE', {
          timeZone: 'Europe/Berlin',
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        console.error('Error formatting date:', error);
        return 'Ungültiges Datum';
      }
    },

    formatTimeslot() {
      const slots = this.formData.selectedAppointmentSlot?.appointmentSlots;
      if (!slots || slots.length < 2) return 'Kein Zeitslot verfügbar';

      const startTime = this.formatToMunichTime(slots[0].start);
      const endTime = this.formatToMunichTime(slots[1].start);

      return `Abgabe: <strong>${startTime}</strong><br /> Abholung: <strong>${endTime}</strong>`;
    },
    getStartTime() {
      const slots = this.formData.selectedAppointmentSlot?.appointmentSlots;
      if (!slots || slots.length < 2) return 'Kein Zeitslot verfügbar';
      return this.formatToMunichTime(slots[0].start);
    },
    getEndTime() {
      const slots = this.formData.selectedAppointmentSlot?.appointmentSlots;
      if (!slots || slots.length < 2) return 'Kein Zeitslot verfügbar';
      return this.formatToMunichTime(slots[1].start);
    },
    setVehicle(vehicle) {

      if(!vehicle) {
        this.formData.brand = '';
        this.formData.model = '';
        this.formData.ez = '';
        this.formData.licenseplate = '';
        this.formData.vin = '';
        this.formData.vehicleId = false
      }

      this.formData.brand = vehicle.brand;
      this.formData.model = vehicle.model;
      if(vehicle.registration_date) {
        this.formData.ez = moment(vehicle.registration_date).format('YYYY-MM-DD');
      }
      this.formData.licenseplate = vehicle.licenseplate;
      this.formData.vin = vehicle.vin;
      this.formData.vehicleId = vehicle.id;

    },
    async onSubmitAppointment() {
      // Clear previous errors
      this.formerrors = [];
      this.apiError = '';

      // Validate required fields
      if (this.formData.lastname === '') {
        this.formerrors.push('lastname');
      }
      if (this.formData.mobile === '' || !this.isPhoneValid) {
        this.formerrors.push('mobile');
      }
      if (this.formData.licenseplate === '') {
        this.formerrors.push('licenseplate');
      }
      if (this.formData.manufacturer === '') {
        this.formerrors.push('manufacturer');
      }

      // Validate Fahrzeugschein if required
      if (this.content && this.content.setting_service_registration_required && this.formData.files_registration.length === 0) {
        this.formerrors.push('registration_document');
      }

      // If there are validation errors, don't proceed
      if (this.formerrors.length > 0) {
        return;
      }

      // Submit to API
      this.isSubmitting = true;

      try {
        const appointmentData = {
          ...this.formData,
          store_id: this.studioId
        };

        console.log(appointmentData);

        const response = await fetch('/api/appointment/send-verification', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify(appointmentData)
        });

        const data = await response.json();

        if (response.ok) {
          // Success - store verification token and navigate to verification
          localStorage.setItem('verificationToken', data.verification_token);
          //localStorage.setItem('appointmentData', JSON.stringify(appointmentData));

          this.showPhoneVerificationBox = true;

          // Navigate to phone verification
          //this.$router.push('/phone-verification');
          /*if (this.$router) {
            this.$router.push('/phone-verification');
          } else {
            window.location.hash = '#/phone-verification';
          }*/
        } else {
          // Handle API errors
          this.apiError = data.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.';
        }
      } catch (error) {
        console.error('API Error:', error);
        this.apiError = 'Verbindungsfehler. Bitte prüfen Sie Ihre Internetverbindung.';
      } finally {
        this.isSubmitting = false;
      }
    },
    goBack() {
      // Go back using hash navigation
      window.history.back();
    },
    isDamageWindowOpen(value) {
      this.hideSubmitButtonOnlineOffer = value;
    },
    onFahrzeugscheinUpdate(files) {
      this.formData.files_registration = files;
    },
    onPhoneValidate(phoneObject) {
      console.log('Phone validation:', phoneObject);
      this.isPhoneValid = phoneObject.valid;
      this.phoneObject = phoneObject;
    },
    onPhoneInput(formattedNumber, phoneObject) {
      console.log('Phone input - Formatted:', formattedNumber);
      console.log('Phone input - Object:', phoneObject);

      // Store the formatted international number if valid
      if (phoneObject && phoneObject.valid) {
        this.formData.mobile = phoneObject.formatInternational || formattedNumber;
        this.isPhoneValid = true;
        this.phoneObject = phoneObject;
      } else {
        // Keep the current input but mark as invalid
        this.formData.mobile = formattedNumber;
        this.isPhoneValid = false;
      }
    },
    async onVerficationStatus(payload) {
      console.log(payload);

      if(payload.message == 'success') {
        // Only show loading spinner for successful verification
        this.waitForBookingConfirmation = true;

        const appointmentData = {
          formdata: this.formData
        };

        console.log(appointmentData);

        try {
          const response = await fetch(`/api/ksr/${this.studioId}/guest-service/confirm`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify(appointmentData)
          });

          const result = await response.json();

          console.log(result);

          this.waitForBookingConfirmation = false;

          if (response.ok) {
            console.log('Appointment confirmed successfully:', result);
            this.$router.push('/thank-you');
          } else {
            console.error('Error confirming appointment:', result);
            this.apiError = result.message || 'An error occurred while confirming the appointment. Please try again.';
          }
        } catch (error) {
          console.error('Network Error:', error);
          this.apiError = 'Connection error. Please check your internet connection.';
          this.waitForBookingConfirmation = false;
        }
      }
      else {
        // Verification failed - show error message, don't show loading spinner
        this.verificationError = payload.message;
        // Make sure loading spinner is hidden
        this.waitForBookingConfirmation = false;
      }
    },
    onSubmit() {

      this.formerrors = [];

      // Validate Fahrzeugschein if required
      if (this.content && this.content.setting_service_registration_required && this.formData.files_registration.length === 0) {
        this.formerrors.push('registration_document');
      }

      if(!this.formerrors.length) {

        // Submit to API
        this.isSubmitting = true;

        this.loading = true;
        var _this = this;

        if(this.identityToken) {

          let data = {
            formdata: this.formData,
            formdata_offer: this.formData,
            insuranceData: this.insuranceData
          };

          console.log(data);

          axios.post('/api/ksr/'+this.studioId+'/offer/kit/confirm?identityToken='+this.identityToken, data)
              .catch(function (error) {
                // empty catch
              })
              .then((response) => {

                // Attach Documents to damage
                let uploadDocumentsChildFormdata = this.$refs.uploadDocumentsChild.formdata;
                let jobId = response.data;

                console.log(uploadDocumentsChildFormdata);
                console.log(jobId);

                uploadDocumentsChildFormdata.jobId = jobId;
                if(uploadDocumentsChildFormdata && jobId) {

                  let data = {
                    formdata: uploadDocumentsChildFormdata,
                    suppressMail: true
                  }
                  axios.post('/api/ksr/upload/documents/send?identityToken='+this.identityToken, data)
                      .then((response) => {
                        _this.$refs.uploadDocumentsChild.formdata.files_registration = [];
                        _this.$refs.uploadDocumentsChild.resetChild();
                        this.$router.push('/thank-you');
                      });
                }
                else {
                  //_this.$refs.carousel.goTo(3, true);
                  //_this.step = 3;
                  this.$router.push('/thank-you');
                }

              });

        }

      }


    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.vue-tel-input {
  height: 50px;
  border: 1px solid #dee2e6;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  min-height: 200px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
  text-align: center;
}
</style>
